<template>
	<aside class="sidebar" :class="opened ? 'opened' : ''">
		<Environment />
		<router-link v-if="isDesktop" class="sidebar__top" :to="{ name: 'Dashboard' }">
			<img src="@/assets/images/logo-light.png" alt="Volvo" />
		</router-link>
		<span v-else class="sidebar__head">
			<Logo />
			<svg @click="close()" class="icon-button stroke" viewBox="0 0 24 24">
				<path d="M4.222 4.222l15.556 15.556M4.222 19.778L19.778 4.222"></path>
			</svg>
		</span>
		<nav class="navigation navigation--primary">
			<b-tooltip v-for="(r, i) in primary" :label="title(r)" :key="i" type="is-white" position="is-right" v-show="verifyShowMenu(r.name)">
				<router-link class="navigation__link" @click.native="close()" :to="r">
					<span v-if="!isDesktop">{{ title(r) }}</span>
					<svg-icon v-else :icon="r.icon"></svg-icon>
				</router-link>
			</b-tooltip>
		</nav>
		<nav class="navigation navigation--secondary">
			<b-tooltip label="Perfil" type="is-white" position="is-right">
				<router-link class="navigation__link" @click.native="close()" :to="{ name: 'Perfil' }">
					<span v-if="!isDesktop">Perfil</span>
					<svg-icon v-else icon="profile"></svg-icon>
				</router-link>
			</b-tooltip>
			<b-tooltip label="Sair" type="is-white" position="is-right">
				<a @click="logout" class="navigation__link navigation__link--logout">
					<span v-if="!isDesktop">Sair</span>
					<svg-icon v-else icon="logout"></svg-icon>
				</a>
			</b-tooltip>
		</nav>
	</aside>
</template>

<script>
import Menu from '@/router/menu'
import Logo from '@/components/Logo'
import Icon from '@/components/Icon'
import Environment from '@/components/Environment'
import Api from '@/services/api'
import eventHub from '@/services/eventHub'
import { responsive } from '@/mixins/responsive'
import { mapActions, mapState } from 'vuex'

export default {
	name: 'Sidebar',
	mixins: [responsive],
	components: {
		Logo,
		Environment,
		'svg-icon': Icon
	},
	data() {
		return {
			expandOnHover: false,
			opened: false,
			overlay: false,
			id: ''
		}
	},
	methods: {
		...mapActions('user', ['getUserData', 'deleteUserData']),
		close() {
			this.opened = false
			eventHub.$emit('close-menu')
		},
		title(r) {
			return r.meta ? r.meta.title : r.name
		},
		async logout(event) {
			try {
				event.preventDefault()
				await Api.post('user/logout')
			} catch (e) {
				console.log(e)
			}

			this.deleteUserData()
			await this.$router.push('/')
		},
		verifyShowMenu(name) {
			if (this.permissions) {
				const menu = this.permissions.find(e => e.slug === name.toLowerCase())

				if (['ranking', 'contests'].includes(name.toLowerCase())  && ['master', 'manager'].includes(this.user.role.name)) {
					return true
				}

				if (menu) {
					return menu.role.read
				}
			}

			return false
		}
	},
	created() {
		if (!this.user) {
			this.getUserData()
		}
	},
	mounted() {
		eventHub.$on('open-menu', () => {
			this.opened = true
		})
	},
	watch: {
		permissions (v) {
			if (v) {
				const endpoint = window.location.href.split('/')[3]
				const permission = this.permissions.find(e => e.slug === endpoint.toLowerCase())

				if (['ranking', 'contests'].includes(endpoint) && !['master', 'manager'].includes(this.user.role.name)) {
					this.$router.push('/error')
				}

				if (permission && !permission.role.read) {
					this.$router.push('/error')
				}
			}
		}
	},
	computed: {
		primary() {
			return Menu
		},
		...mapState('user', [
			'user',
			'permissions'
		])
	}
}
</script>
